<template>
    <div class="horizontal-tab">
        <div class="card card-with-shadow border-0">
            <nav>
                <div class="nav nav-tabs">
                    <a v-for="(tab, index) in filteredTab" :key="index"
                       class="nav-item p-primary text-capitalize"
                       :style="tab.style"
                       :class="{'active':currentIndex == index}"
                       data-toggle="tab" :href="'#'+tab.name+'-'+index"
                       @click.prevent="loadComponent(tab,index)">
                        <span v-if="tab.icon" class="mr-2"><app-icon :name="tab.icon"/></span>{{tab.name}}
                    </a>
                </div>
            </nav>
            <div class="tab-content p-2" style="position: relative;">
                <button
                    v-if="onRefresh"
                    class="tab-refresh-icon-btn"
                    :class="{ 'is-refreshing': refreshing }"
                    :disabled="refreshing"
                    @click.prevent="handleRefresh"
                    title="Refresh"
                >
                    <i :class="refreshing ? 'el-icon-loading' : 'el-icon-refresh'"></i>
                </button>

                <transition name="tab-fade">
                    <div v-if="refreshing" class="tab-refresh-overlay">
                        <div class="tab-refresh-overlay__spinner">
                            <i class="el-icon-loading"></i>
                            <span>Refreshing...</span>
                        </div>
                    </div>
                </transition>

                <div class="tab-pane fade show active"
                     :class="{ 'tab-content--loading': refreshing }"
                     :id="componentId">
                    <component :is="componentName" v-bind="componentProps" v-on="$listeners"/>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
    import {TabMixin} from './mixins/TabMixin';
    export default {
        name: "HorizontalCustomizedTab",
        mixins: [TabMixin],
        props: {
            onRefresh: {
                type: Function,
                default: null,
            }
        },
        data() {
            return {
                refreshing: false,
            };
        },
        methods: {
            async handleRefresh() {
                if (!this.onRefresh || this.refreshing) return;
                this.refreshing = true;
                try {
                    await Promise.resolve(this.onRefresh(this.currentIndex));
                } finally {
                    this.refreshing = false;
                }
            }
        }
    }
</script>

<style scoped>
.tab-refresh-icon-btn {
    position: absolute;
    top: 10px;
    right: 12px;
    z-index: 10;
    background: #f0f4ff;
    border: 1px solid #d0e2fd;
    border-radius: 8px;
    width: 36px;
    height: 36px;
    display: flex;
    align-items: center;
    justify-content: center;
    cursor: pointer;
    transition: background 0.18s ease, box-shadow 0.18s ease, transform 0.1s ease;
    color: #1a56db;
    font-size: 18px;
}

.tab-refresh-icon-btn:hover:not(:disabled) {
    background: #d0e2fd;
    box-shadow: 0 2px 8px rgba(26, 86, 219, 0.18);
}

.tab-refresh-icon-btn:active {
    transform: scale(0.93);
}

.tab-refresh-icon-btn:disabled {
    opacity: 0.55;
    cursor: not-allowed;
}

.tab-content--loading {
    opacity: 0.4;
    pointer-events: none;
    transition: opacity 0.2s ease;
    user-select: none;
}

.tab-refresh-overlay {
    position: absolute;
    inset: 0;
    z-index: 20;
    display: flex;
    align-items: center;
    justify-content: center;
    background: rgba(255, 255, 255, 0.55);
    backdrop-filter: blur(2px);
    border-radius: 4px;
}

.tab-refresh-overlay__spinner {
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: 8px;
    color: #1a56db;
    font-size: 13px;
    font-weight: 500;
}

.tab-refresh-overlay__spinner i {
    font-size: 28px;
}

.tab-fade-enter-active,
.tab-fade-leave-active {
    transition: opacity 0.2s ease;
}

.tab-fade-enter,
.tab-fade-leave-to {
    opacity: 0;
}
</style>
